






































































import OrderContentTop from '@/components/common/order/OrderContentTop.vue';
import ItemTable from '@/components/common/order/ItemTable.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import OrderListGrids from '@/components/order/mixins/OrderListGrids';
import { Component, Mixins, Ref } from 'vue-property-decorator';
import { ncpPopup } from '@/utils/commonUtils';
import OrderGridBrokenFreeGiftMixin from '@/views/order/mixins/OrderGridBrokenFreeGiftMixin.vue';
import {GetOrderOptionsOrderGridContentsItem} from 'ncp-api-supporter/dist/types/modules/order/backendOrderOption';
import {CustomGroupFlagCallbackInfo} from '@/components/common/order/mixins/OrderGridsColums';

@Component({
  components: { OrderContentTop, PageTitle, ItemTable },
})
export default class OrderList extends Mixins(OrderListGrids, OrderGridBrokenFreeGiftMixin) {
  @Ref('grid') protected readonly gridRef: ItemTable;
  private orderListContent: any = [];
  private theExcelDownIfo: any = {
    fileName: '',
    columns: {},
    formatters: {},
  };
  private totalCount: any = 0;
  private initPageSize: number = 30;
  private request: any = {
    params: {},
  };
  private memberGroup: any[] = [];
  private showMemberGroup: boolean = false;
  private exchangeMemberData: any = {
    id: 'memberGroup',
    width: 400,
    maxHeight: 300,
    title: 'ORDER_LIST_GRIDS_MEMBER_GROUP_LAYER_TITLE',
    hasConfirmBtn: false,
  };
  public ifExchange: boolean = false;
  private exchangeHelpData: any = {
    id: 'exchangeHelp',
    width: 500,
    title: 'ORDER_LIST_GRIDS_PAY_DONE_LAYER_TITLE',
    nonFooter: true
  };
  private contentBottomOption: any = {
    gridName: 'ORDER_LIQUOR_INFO_AGREEMENT_GRID',
    haveConfigBtn: true,
    haveExcelDownBtn: true,
    excelDownInfo: {
      columns: {},
      fileName: '',
      nameDateFormat: 'YYYYMMDD_HHmmss',
      formatters: {},
    },
  };

  private created(): void {}
  private mounted(): void {
    $('body').on('click', '.ordererPopup', $.proxy(this.orderNameClick, this));
    $('body').on('click', '.member-group-name-grid', $.proxy(this.clickMemberGroupNameInGrid, this));
    $('body').on('click', '#exchangeHelpBtn', $.proxy(() => (this.ifExchange = true), this));
  }
  private orderNameClick(e: any): void {
    const memberno = $(e.target).data('memberno');
    ncpPopup(`/member/popup/crm/${memberno}`, 'ORDER_LIST_GRIDS_ORDER_NAME_POPUP_TITLE', 1100, 980);
  }
  private clickMemberGroupNameInGrid(e: any): void {
    this.memberGroup = [];
    this.memberGroup = JSON.parse(
      $(e.target)
        .data('json')
        .replace(/\\\"/g, '"'),
    );
    this.showMemberGroup = true;
  }
  private handleInitRequest(e: any): void {
    this.request = {
      params: {},
    };
    this.$set(this.request, 'params', e);
  }

  public initExcelColums(): void {
    let columns: any = this.gridProps.columns.map((item: any) => {
      if (item.visible === true) {
        return item.name;
      }
    });
    this.contentBottomOption.excelDownInfo.columns = [];
    columns.forEach((el: any): any => {
      this.contentBottomOption.excelDownInfo.columns[el] = this.excelDownInfo.columns[el];
    });
    this.contentBottomOption.excelDownInfo.formatters = this.excelDownInfo.formatters;
    this.contentBottomOption.excelDownInfo.fileName = 'order_';
  }
  private handleSearch(e: any, page: number = 1): void {
    this.request = {
      params: {},
    };
    this.$set(this.request, 'params', e);
    this.request.params.page = page || 1;
    this.request.params.size = this.size;
    this.request.params.searchDateType = 'ORDER_YMDT';
    $('#loading').show();
		this.fetchOrderOptionsOrderGrid(this.request, page);
  }

  private handleCancel(): void {}
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    this.request.params.page = page;
    this.request.params.size = this.size;
    this.request.params.searchDateType = 'ORDER_YMDT';
    $('#loading').show();

		this.fetchOrderOptionsOrderGrid(this.request, page);
  }


	private fetchOrderOptionsOrderGrid(request, page: number) {
		this.$api
			.getOrderOptionsOrderGrid(request)
			.then(({ data }) => {
				this.orderListContent = [];

				if (data.contents.length > 0) {
					this.formatOrderListContent([...data.contents]);
					this.mergeOrderListContentRow();
					this.setCommunicateFailBgColor(this.orderListContent, this.gridRef);
				}

				this.setTotalCount(data.totalCount);
				this.setGridPropsOptionsForPage(page, data.totalCount);
			})
			.finally((): any => {
				$('#loading').hide();
			});
	}

	private formatOrderListContent(contents: GetOrderOptionsOrderGridContentsItem[]) {
		this.orderListContent = [
			...this.formatterList(
				contents,
				'orderDeliveryGridDatas',
				'orderProductGridDatas',
				'orderProductOptionGridDatas',
			),
		];
	}

	private get rowKeyInfoToMergeRow() {
		return {
			bigRow: [
				'platformType',
				'mallNo',
				'orderRegisterType',
				'reservation',
				'memberGroupInfoJson',
				'recommenderId',
				'payType',
				'orderNo',
				'ordererName',
				'ordererContact1',
				'memberNo',
			],
			midRow: [
				'receiverName',
				'receiverContact1',
				'receiverZipCd',
				'address',
				'shippingNo',
				'deliveryMemo',
				'deliveryAmtInAdvanceYn',
				'deliveryConditionType',
				'customsIdNumber',
				'deliveryType',
				'deliveryCompanyType',
				'invoiceNo',
        'lastSubPayAmt',
        'lastMainPayAmt',
			],
			smallRow: [
				'shippingAreaType',
				'partnerNo',
				'hsCode',
				'mallProductNo',
				'productManagementCd',
				'productName',
				'productNameEn',
				'totalBuyAmt',
			]
		}
	}

	private mergeOrderListContentRow() {
		const customGroupFlagCallbackInfo: CustomGroupFlagCallbackInfo = {
			small: (item, originFlag) => item.isFreeGift && originFlag === 'mallProductNo' ? 'orderProductOptionNo': originFlag
		}

		this.orderListContent = [
			...this.meargeRow(
				this.orderListContent,
				this.rowKeyInfoToMergeRow.bigRow,
				this.rowKeyInfoToMergeRow.midRow,
				this.rowKeyInfoToMergeRow.smallRow,
				'orderNo',
				'shippingNo',
				'mallProductNo',
				customGroupFlagCallbackInfo
			),
		];
	}

	private setTotalCount(totalCount: number) {
		this.totalCount = totalCount;
	}

	private setGridPropsOptionsForPage(page: number, totalCount: number) {
		this.gridProps.options.pageOptions.page = page;
		this.gridProps.options.pageOptions.perPage = this.size;
		this.gridProps.options.pageOptions.totalCount = totalCount;
	}

}
